import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { componentState } from "../../../atoms/componentState";
import { useRecoilState, useSetRecoilState } from "recoil";
import Registros from "./components/registros";
import {
  CEPFormater,
  CNPJFormater,
  CPFFormater,
  PhoneFormater,
} from "../../../defaultFunctions/formaters";
import ClientApi from "../../../services/clientApi";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../routes/privateRoute";
import { ClientInterface } from "../../../interfaces/defaultInterfaces";
import moment from "moment";
import { FaPlay } from "react-icons/fa";
import { customColors } from "../../../atoms/customColors";

export default function DadosPessoais() {
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Dados Pessoais");
    getClientByID();
  }, []);

  const colors = useRecoilState(customColors)[0];

  const [cliente, setCliente] = useState<ClientInterface>();

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);

  async function getClientByID() {
    try {
      const response = await ClientApi.getClientPerId(id);
      //   console.log("response do cliente", response);
      setCliente(response);
    } catch (error) {
      console.log("error :", error);
    }
  }
  return (
    <Flex
      w={"99.5%"}
      h={"99.5%"}
      flexDirection={"column"}
      bgColor={"#F5F5F5"}
      //   justifyContent={"center"}
      alignItems={"center"}
    >
      <Flex
        w={"98%"}
        h={"10%"}
        alignItems={"center"}
        mx={6}
        borderBottom={`2px solid ${colors.BLUEMONEDDBUTTONS}`}
      >
        <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
        <Text color={colors.BLUEMONEDDBUTTONS} fontSize={"35px"} fontWeight={"bold"} ml={2}>
          Meu perfil
        </Text>
      </Flex>
      <Text fontSize={"20px"} color={colors.BLUEMONEDDBUTTONS} fontWeight={"500"} mt={2}> {/*"#1C3E92" */}
        DADOS DE CADASTRO
      </Text>
      <Flex
        w={"70%"}
        h={"90%"}
        alignItems={"center"}
        mx={6}
        bgColor={"#F7F7F7"}
      >
        <Flex
          w={"50%"}
          h={"100%"}
          //   bgColor={"blue"}
          flexDirection={"column"}
          py={4}
        >
          <Registros
            title={cliente && cliente.isCnpj === true ? "CNPJ" : "CPF"}
            value={cliente && cliente ? CNPJFormater(cliente.cnpj) : ""}
          />
          <Registros
            title={cliente && cliente.isCnpj === true ? "Razão Social" : "Nome"}
            value={cliente && cliente.razaoSocial ? cliente.razaoSocial : ""}
          />

          <Registros
            title={
              cliente && cliente.isCnpj === true
                ? "Data da Criação"
                : "Data de Nascimento"
            }
            value={
              cliente && cliente.dataAbertura
                ? moment(cliente.dataAbertura).format("DD/MM/YYYY")
                : ""
            }
          />
          <Registros
            title={"E-mail"}
            value={cliente && cliente.email ? cliente.email : ""}
          />
          <Registros
            title={"Nome Fantasia"}
            value={cliente && cliente.nomeFantasia ? cliente.nomeFantasia : ""}
          />
          <Registros
            title={"Telefone"}
            value={
              cliente && cliente.telefone ? PhoneFormater(cliente.telefone) : ""
            }
          />
        </Flex>
        <Flex
          w={"50%"}
          h={"100%"}
          //   bgColor={"green"}
          flexDirection={"column"}
          py={4}
          px={4}
        >
          <Registros
            title={"CEP"}
            value={cliente ? CEPFormater(cliente.enderCep) : ""}
          />
          <Registros
            title={"Endereço"}
            value={cliente ? `${cliente.enderRua}, ${cliente.enderNumero}` : ""}
          />

          <Registros
            title={"Complemento"}
            value={cliente ? cliente.enderComplemento : ""}
          />
          <Registros
            title={"Bairro"}
            value={cliente && cliente.enderBairro ? cliente.enderBairro : ""}
          />
          <Registros
            title={"Cidade"}
            value={
              cliente && cliente.enderMunicipio ? cliente.enderMunicipio : ""
            }
          />
          <Registros
            title={"Estado"}
            value={cliente && cliente.enderUF ? cliente.enderUF : ""}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
